var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"pb-0"},[_c('v-autocomplete',{attrs:{"items":_vm.reasons,"loading":_vm.$apollo.loading,"item-value":"uuid","item-text":"name","outlined":"","label":"Orsak","disabled":_vm.disabled,"persistent-hint":""},model:{value:(_vm.reason_uuid),callback:function ($$v) {_vm.reason_uuid=$$v},expression:"reason_uuid"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }